import { Component } from '@angular/core';

@Component({
  selector: 'app-page-reload',
  templateUrl: './page-reload.component.html',
  styleUrl: './page-reload.component.scss',
  standalone: false,
})
export class PageReloadComponent {}
